/**
 * Do not edit directly
 * Generated on Thu, 29 Sep 2022 18:15:25 GMT
 */

export const componentTextFieldContainerBackgroundColor = "#fff";
export const componentTextFieldContainerBorderColorDefault = "#909196";
export const componentTextFieldContainerBorderColorHover = "#2e2f32";
export const componentTextFieldContainerBorderColorFocus = "#2e2f32";
export const componentTextFieldContainerBorderColorDisabled = "#babbbe";
export const componentTextFieldContainerBorderRadius = "0.25rem";
export const componentTextFieldContainerBorderWidthDefault = "0.0625rem";
export const componentTextFieldContainerBorderWidthHover = "0.0625rem";
export const componentTextFieldContainerBorderWidthFocus = "0.125rem";
export const componentTextFieldContainerBorderWidthDisabled = "0.0625rem";
export const componentTextFieldContainerSizeLargePaddingHorizontal = "1rem";
export const componentTextFieldContainerSizeLargePaddingVertical = "1rem";
export const componentTextFieldContainerSizeSmallPaddingHorizontal = "0.75rem";
export const componentTextFieldContainerSizeSmallPaddingVertical = "0.5rem";
export const componentTextFieldContainerStateErrorBorderColorDefault = "#de1c24";
export const componentTextFieldContainerStateErrorBorderColorHover = "#de1c24";
export const componentTextFieldContainerStateErrorBorderColorFocus = "#de1c24";
export const componentTextFieldContainerStateErrorBorderColorDisabled = "#de1c24";
export const componentTextFieldContainerStateHasLeadingIconSizeSmallPaddingLeft = "2.75rem";
export const componentTextFieldContainerStateHasLeadingIconSizeLargePaddingLeft = "3.25rem";
export const componentTextFieldContainerStateReadOnlyBorderColorDefault = "transparent";
export const componentTextFieldContainerStateReadOnlyBorderColorHover = "transparent";
export const componentTextFieldContainerStateReadOnlyBorderColorFocus = "#2e2f32";
export const componentTextFieldContainerStateReadOnlyBorderColorDisabled = "transparent";
export const componentTextFieldHelperTextAliasName = "component.form.helperText";
export const componentTextFieldHelperTextMarginHorizontal = "0.25rem";
export const componentTextFieldHelperTextMarginTop = "0.25rem";
export const componentTextFieldLabelAliasName = "component.form.label";
export const componentTextFieldLabelMarginBottom = "0.25rem";
export const componentTextFieldLabelMarginHorizontal = "0.25rem";
export const componentTextFieldLeadingIconIconColorDefault = "#74767c";
export const componentTextFieldLeadingIconIconColorHover = "#74767c";
export const componentTextFieldLeadingIconIconColorFocus = "#74767c";
export const componentTextFieldLeadingIconIconColorDisabled = "#babbbe";
export const componentTextFieldLeadingIconIconSize = "medium";
export const componentTextFieldLeadingIconSizeSmallOffsetLeft = "0.75rem";
export const componentTextFieldLeadingIconSizeSmallOffsetTop = "0.5rem";
export const componentTextFieldLeadingIconSizeLargeOffsetLeft = "1rem";
export const componentTextFieldLeadingIconSizeLargeOffsetTop = "1rem";
export const componentTextFieldTrailingTextColorDefault = "#2e2f32";
export const componentTextFieldTrailingTextColorHover = "#2e2f32";
export const componentTextFieldTrailingTextColorFocus = "#2e2f32";
export const componentTextFieldTrailingTextColorDisabled = "#babbbe";
export const componentTextFieldValueFontFamily = "Bogle, 'Helvetica Neue', Helvetica, Arial, sans-serif";
export const componentTextFieldValueFontWeight = "400";
export const componentTextFieldValuePlaceholderTextColor = "#74767c";
export const componentTextFieldValueSizeLargeFontSize = "1rem";
export const componentTextFieldValueSizeLargeLineHeight = "1.5rem";
export const componentTextFieldValueSizeSmallFontSize = "0.875rem";
export const componentTextFieldValueSizeSmallLineHeight = "1.5rem"; // This takes into account the extra 4px missed in figma: 20px + 4px = 24px
export const componentTextFieldValueTextColorDefault = "#2e2f32";
export const componentTextFieldValueTextColorHover = "#2e2f32";
export const componentTextFieldValueTextColorFocus = "#2e2f32";
export const componentTextFieldValueTextColorActive = "#2e2f32";
export const componentTextFieldValueTextColorDisabled = "#babbbe";